"use strict";

var ADDRESS = {
  STORAGE: 'CAPSULE-JS-STORAGE',
  MEMORY: 'CAPSULE-JS-MEMORY',
  CACHE: 'CAPSULE-JS-CACHE'
};
module.exports = ADDRESS;